// extracted by mini-css-extract-plugin
export default {"tasksPage":"Tasks_tasksPage__EiP9U","tasksList":"Tasks_tasksList__w0Vfv","tasksEmpty":"Tasks_tasksEmpty__Zp+Li"};